import { Observable } from 'rxjs';

/**
 * These utils plant a hidden id on a busy signal to denote it has been registered and is
 * being tracked as a lazy busy signal.
 *
 * The lazy busy signal loader can then use these ids to identify the object in its tracking map.
 **/

const BusySignalId = Symbol.for('LazyBusySignal');

function defineSignalIdProperty(busy$: Observable<boolean>, id: symbol | undefined): void {
    Object.defineProperty(busy$, BusySignalId, {
        value: id,
        // Allow redefinitions
        configurable: true,
        // Prevent writing to it from outside
        writable: false,
        enumerable: false
    });
}

export function getBusySignalId(busy$: Observable<boolean>): symbol | undefined {
    return (busy$ as any)[BusySignalId];
}

export function setBusySignalId(busy$: Observable<boolean>): symbol {
    const id = Symbol('LazyBusyStream');

    defineSignalIdProperty(busy$, id);

    return id;
}

export function clearBusySignalId(busy$: Observable<boolean>): void {
    defineSignalIdProperty(busy$, undefined);
}
